const API_BASE = import.meta.env.VITE_API_URL ?? "/api";
export const apiUrl = (path: string) => `${API_BASE}${path}`;

const cookieValue = (name: string) =>
  document.cookie.split("; ").find((entry) => entry.startsWith(`${name}=`))?.split("=")[1];

export class ApiError<TBody = { error?: string }> extends Error {
  readonly status: number;
  readonly body: TBody;

  constructor(status: number, body: TBody, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) headers.set("content-type", "application/json");
  const csrf = cookieValue("pt_csrf");
  if (csrf && !["GET", "HEAD"].includes(init.method ?? "GET")) headers.set("x-csrf-token", decodeURIComponent(csrf));
  const response = await fetch(apiUrl(path), {
    ...init,
    headers,
    credentials: "include",
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: "request_failed" })) as { error?: string };
    throw new ApiError(response.status, body, body.error ?? `HTTP ${response.status}`);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
